/**
 * Kiwi Driver Enhanced Scripts
 * GSAP animations and interactive functionality
 * Following GSAP best practices from cursor rules
 */

/**
 * Fire KiwiDriver signup start tracking event
 * Fires ami_rr_signup_start_free + Google Floodlight (Activity ID: 186132457) + Meta Pixel Lead
 */
function fireKiwiDriverSignupStart() {
  // Push to dataLayer for GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'ami_rr_signup_start_free' });
  
  // Fire Google Floodlight conversion (Activity ID: 186132457)
  if (typeof gtag === 'function') {
    gtag('event', 'conversion', {
      'send_to': 'DC-8062289/186132457',
      'value': 0,
      'currency': 'NZD'
    });
  }
  
  // Fire Meta Pixel Lead event
  if (typeof fbq === 'function') {
    fbq('track', 'Lead', {
      content_name: 'ami_rr_signup_start_free'
    });
    // console.log('[AMI Tracking] Meta Pixel: Lead', { content_name: 'ami_rr_signup_start_free' });
  }
  
  // console.log('[AMI Tracking] Event fired: ami_rr_signup_start_free (Floodlight: 186132457)');
}

/**
 * Initialize tracking for KiwiDriver signup buttons
 * Tracks clicks on Join Now / Sign Up buttons that lead to the signup form
 */
function initKiwiDriverSignupTracking() {
  // Select all CTA buttons on the KiwiDriver landing page
  // Exclude the eligibility card button which links to paid product
  const signupButtons = document.querySelectorAll([
    '[href="https://amiroadsiderescue.co.nz/pages/new-driver"]'
  ].join(', '));

  signupButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      // Fire tracking event before navigation
      fireKiwiDriverSignupStart();
    });
  });

  // console.log('[AMI Tracking] KiwiDriver signup tracking initialized for', signupButtons.length, 'buttons');
}

document.addEventListener('DOMContentLoaded', function() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Initialize KiwiDriver signup tracking
  initKiwiDriverSignupTracking();

  // Check if GSAP is available
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded - animations disabled');
    showElementsWithoutAnimation();
    initFaqAccordion();
    return;
  }

  // Register ScrollTrigger if available
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  if (prefersReducedMotion) {
    showElementsWithoutAnimation();
  } else {
    initAnimations();
  }

  initFaqAccordion();
  adjustYellowStripeHeight();
  initHelpBox();

  // Adjust SVG stripe on resize
  window.addEventListener('resize', adjustYellowStripeHeight);

  // Shopify Theme Editor compatibility
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.ami-rescue-wrapper-v2')) {
        // Clean up existing ScrollTriggers
        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.getAll().forEach(function(trigger) {
            trigger.kill();
          });
        }
        
        if (prefersReducedMotion) {
          showElementsWithoutAnimation();
        } else {
          initAnimations();
        }
        initFaqAccordion();
        adjustYellowStripeHeight();
      }
    });
  }
});

/**
 * Adjust yellow stripe SVG height to span from two_column_list to eligibility_section
 */
function adjustYellowStripeHeight() {
  const twoColList = document.querySelector('.ami-two-col-list');
  const eligibilitySection = document.querySelector('.ami-eligibility');
  const yellowStripe = document.querySelector('.ami-yellow-stripe-svg');
  
  if (!twoColList || !eligibilitySection || !yellowStripe) {
    return;
  }

  // Only adjust if viewport is wide enough (1685px+)
  if (window.innerWidth < 1685) {
    return;
  }

  // Get positions
  const twoColRect = twoColList.getBoundingClientRect();
  const eligibilityRect = eligibilitySection.getBoundingClientRect();
  
  // Calculate height needed to span from top of two_column_list to bottom of eligibility_section
  const topPosition = twoColRect.top + window.scrollY;
  const bottomPosition = eligibilityRect.bottom + window.scrollY;
  const totalHeight = bottomPosition - topPosition;
  
  // Apply the calculated height
  yellowStripe.style.height = totalHeight + 'px';
}

/**
 * Show all animated elements without animation
 */
function showElementsWithoutAnimation() {
  const elements = [
    '.ami-hero-v2-card',
    '.ami-tagline-text',
    '.ami-benefit-v2-card',
    '.ami-content-v2-content',
    '.ami-content-v2-image',
    '.ami-two-col-list-grid',
    '.ami-two-col-list-item',
    '.ami-eligibility-content',
    '.ami-eligibility-card-wrapper',
    '.ami-faq-v2-item',
    '.ami-faq-v2-button-wrapper',
    '.ami-faq-v2-disclaimer',
    '.ami-final-cta-content'
  ];

  elements.forEach(function(selector) {
    const els = document.querySelectorAll(selector);
    els.forEach(function(el) {
      gsap.set(el, { opacity: 1, x: 0, y: 0, scale: 1 });
    });
  });
}

/**
 * Initialize all GSAP animations
 */
function initAnimations() {
  // Hero card animation - GPU accelerated transform
  const heroCard = document.querySelector('.ami-hero-v2-card');
  if (heroCard) {
    gsap.to(heroCard, {
      opacity: 1,
      x: 0,
      duration: 0.9,
      ease: 'power3.out',
      delay: 0.3
    });
  }

  // Check if ScrollTrigger is available
  if (typeof ScrollTrigger === 'undefined') {
    animateWithoutScrollTrigger();
    return;
  }

  // Tagline animation
  const tagline = document.querySelector('.ami-tagline-text');
  if (tagline) {
    gsap.to(tagline, {
      scrollTrigger: {
        trigger: tagline,
        start: 'top 80%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out'
    });
  }

  // Benefits grid with stagger
  const benefitCards = gsap.utils.toArray('.ami-benefit-v2-card');
  if (benefitCards.length > 0) {
    gsap.to(benefitCards, {
      scrollTrigger: {
        trigger: '.ami-benefits-v2-grid',
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.1,
      ease: 'power2.out'
    });
  }

  // Content + Image sections
  const contentSections = gsap.utils.toArray('.ami-content-v2-content');
  contentSections.forEach(function(content) {
    gsap.to(content, {
      scrollTrigger: {
        trigger: content,
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      x: 0,
      duration: 0.7,
      ease: 'power2.out'
    });
  });

  const imageSections = gsap.utils.toArray('.ami-content-v2-image');
  imageSections.forEach(function(image) {
    gsap.to(image, {
      scrollTrigger: {
        trigger: image,
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      x: 0,
      duration: 0.7,
      ease: 'power2.out'
    });
  });

  // Two column list
  const twoColList = document.querySelector('.ami-two-col-list-grid');
  if (twoColList) {
    gsap.to(twoColList, {
      scrollTrigger: {
        trigger: twoColList,
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: 'power2.out'
    });

    // Stagger animation for list items
    const listItems = gsap.utils.toArray('.ami-two-col-list-item');
    if (listItems.length > 0) {
      gsap.fromTo(listItems, 
        { opacity: 0, x: -20 },
        {
          scrollTrigger: {
            trigger: twoColList,
            start: 'top 75%',
            toggleActions: 'play none none none'
          },
          opacity: 1,
          x: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out',
          delay: 0.2
        }
      );
    }
  }

  // Eligibility section
  const eligibilityContent = document.querySelector('.ami-eligibility-content');
  if (eligibilityContent) {
    gsap.to(eligibilityContent, {
      scrollTrigger: {
        trigger: '.ami-eligibility',
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      x: 0,
      duration: 0.7,
      ease: 'power2.out'
    });
  }

  const eligibilityCard = document.querySelector('.ami-eligibility-card-wrapper');
  if (eligibilityCard) {
    gsap.to(eligibilityCard, {
      scrollTrigger: {
        trigger: '.ami-eligibility',
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      x: 0,
      duration: 0.7,
      delay: 0.2,
      ease: 'power2.out'
    });
  }

  // FAQ items
  const faqItems = gsap.utils.toArray('.ami-faq-v2-item');
  if (faqItems.length > 0) {
    faqItems.forEach(function(item, index) {
      gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        opacity: 1,
        y: 0,
        duration: 0.5,
        delay: index * 0.08,
        ease: 'power2.out'
      });
    });
  }

  // FAQ button
  const faqButton = document.querySelector('.ami-faq-v2-button-wrapper');
  if (faqButton) {
    gsap.to(faqButton, {
      scrollTrigger: {
        trigger: faqButton,
        start: 'top 85%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out'
    });
  }

  // FAQ disclaimer
  const faqDisclaimer = document.querySelector('.ami-faq-v2-disclaimer');
  if (faqDisclaimer) {
    gsap.to(faqDisclaimer, {
      scrollTrigger: {
        trigger: faqDisclaimer,
        start: 'top 85%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out'
    });
  }

  // Final CTA
  const finalCta = document.querySelector('.ami-final-cta-content');
  if (finalCta) {
    gsap.to(finalCta, {
      scrollTrigger: {
        trigger: finalCta,
        start: 'top 75%',
        toggleActions: 'play none none none'
      },
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out'
    });
  }
}

/**
 * Fallback animations without ScrollTrigger
 */
function animateWithoutScrollTrigger() {
  // Tagline
  gsap.to('.ami-tagline-text', {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out',
    delay: 0.8
  });

  // Benefits with stagger
  gsap.to('.ami-benefit-v2-card', {
    opacity: 1,
    y: 0,
    duration: 0.6,
    stagger: 0.1,
    ease: 'power2.out',
    delay: 1
  });

  // Content sections
  gsap.to('.ami-content-v2-content', {
    opacity: 1,
    x: 0,
    duration: 0.7,
    stagger: 0.2,
    ease: 'power2.out',
    delay: 1.2
  });

  gsap.to('.ami-content-v2-image', {
    opacity: 1,
    x: 0,
    duration: 0.7,
    stagger: 0.2,
    ease: 'power2.out',
    delay: 1.3
  });

  // Two column list
  gsap.to('.ami-two-col-list-grid', {
    opacity: 1,
    y: 0,
    duration: 0.7,
    ease: 'power2.out',
    delay: 1.4
  });

  // List items with stagger
  gsap.fromTo('.ami-two-col-list-item', 
    { opacity: 0, x: -20 },
    {
      opacity: 1,
      x: 0,
      duration: 0.5,
      stagger: 0.1,
      ease: 'power2.out',
      delay: 1.6
    }
  );

  // Eligibility section
  gsap.to('.ami-eligibility-content', {
    opacity: 1,
    x: 0,
    duration: 0.7,
    ease: 'power2.out',
    delay: 1.7
  });

  gsap.to('.ami-eligibility-card-wrapper', {
    opacity: 1,
    x: 0,
    duration: 0.7,
    ease: 'power2.out',
    delay: 1.9
  });

  // FAQ items
  gsap.to('.ami-faq-v2-item', {
    opacity: 1,
    y: 0,
    duration: 0.5,
    stagger: 0.08,
    ease: 'power2.out',
    delay: 1.5
  });

  // Final CTA
  gsap.to('.ami-final-cta-content', {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: 'power3.out',
    delay: 1.6
  });
}

/**
 * Initialize FAQ accordion functionality
 */
function initFaqAccordion() {
  const faqQuestions = document.querySelectorAll('.ami-faq-v2-question');

  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement;
      const answer = faqItem.querySelector('.ami-faq-v2-answer');
      const isActive = faqItem.classList.contains('active');

      // Close all other FAQs with animation
      document.querySelectorAll('.ami-faq-v2-item').forEach(function(item) {
        if (item !== faqItem && item.classList.contains('active')) {
          item.classList.remove('active');
          const otherAnswer = item.querySelector('.ami-faq-v2-answer');
          if (otherAnswer) {
            if (typeof gsap !== 'undefined') {
              gsap.to(otherAnswer, {
                maxHeight: 0,
                duration: 0.3,
                ease: 'power2.in'
              });
            } else {
              otherAnswer.style.maxHeight = '0';
            }
          }
        }
      });

      // Toggle current FAQ
      if (!isActive) {
        faqItem.classList.add('active');
        if (typeof gsap !== 'undefined') {
          gsap.to(answer, {
            maxHeight: answer.scrollHeight,
            duration: 0.4,
            ease: 'power2.out'
          });
        } else {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      } else {
        faqItem.classList.remove('active');
        if (typeof gsap !== 'undefined') {
          gsap.to(answer, {
            maxHeight: 0,
            duration: 0.3,
            ease: 'power2.in'
          });
        } else {
          answer.style.maxHeight = '0';
        }
      }
    });
  });
}

/**
 * Initialize floating help box functionality
 */
function initHelpBox() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const helpBox = document.getElementById('helpButton');
  const helpToggle = document.getElementById('helpToggle');
  const helpContent = helpBox ? helpBox.querySelector('.ami-help-float-content') : null;

  if (!helpBox || !helpToggle || !helpContent) {
    return;
  }

  // Wait for GSAP to be available if scripts are deferred
  function initHelpBoxAnimation() {
    // If GSAP is not available, show the box without animation
    if (typeof gsap === 'undefined') {
      helpBox.style.opacity = '1';
      helpBox.style.visibility = 'visible';
      return;
    }

    let isHidden = true;

    /**
     * Calculate hide distance based on content width
     * Only hide the content, keep the toggle visible
     */
    function getHideDistance() {
      return helpContent.offsetWidth;
    }

    /**
     * Update position based on hidden state
     * @param {boolean} animate - Whether to animate the transition
     */
    function updatePosition(animate) {
      const hideDistance = getHideDistance();

      if (isHidden) {
        if (animate && !prefersReducedMotion) {
          helpBox.classList.add('is-hidden');
          gsap.to(helpBox, {
            x: hideDistance,
            duration: 0.4,
            ease: 'power2.in',
          });
        } else {
          helpBox.classList.add('is-hidden');
          gsap.set(helpBox, { x: hideDistance });
        }
      } else {
        if (animate && !prefersReducedMotion) {
          helpBox.classList.remove('is-hidden');
          gsap.to(helpBox, {
            x: 0,
            duration: 0.6,
            ease: 'power2.out',
          });
        } else {
          helpBox.classList.remove('is-hidden');
          gsap.set(helpBox, { x: 0 });
        }
      }
    }

    /**
     * Toggle the help box visibility
     * @param {Event} e - Click event
     */
    function toggleHelpBox(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      isHidden = !isHidden;
      updatePosition(true);
    }

    // Toggle button click handler
    helpToggle.addEventListener('click', toggleHelpBox);

    // Initialize: Start with the help box open (visible)
    isHidden = false;
    updatePosition(false); // Start visible (no animation)

    // Recalculate on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updatePosition(false);
      }, 150);
    });
  }

  // If GSAP is already loaded, initialize immediately
  if (typeof gsap !== 'undefined') {
    initHelpBoxAnimation();
  } else {
    // Wait for GSAP to load (since scripts are deferred)
    let gsapCheckInterval = setInterval(function() {
      if (typeof gsap !== 'undefined') {
        clearInterval(gsapCheckInterval);
        initHelpBoxAnimation();
      }
    }, 50);

    // Timeout after 5 seconds if GSAP never loads
    setTimeout(function() {
      clearInterval(gsapCheckInterval);
      if (typeof gsap === 'undefined') {
        helpBox.style.opacity = '1';
        helpBox.style.visibility = 'visible';
      }
    }, 5000);
  }
}

